import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiFetch from "./utils/api";
import { useAuth } from "./context/AuthContext";

const panelStyle = {
    display: "flex",
    background: "#eaeaea",
    //borderRadius: 10,
    padding: 16,
    height: "auto",
    //boxShadow: "0 1px 3px rgba(16,24,40,0.04)",
    //border: "1px solid rgba(16,24,40,0.04)",
    flexWrap: "wrap",          // allows wrapping when space is tight
    justifyContent: "left",  // center items horizontally (per line)
    alignItems: "center",      // center items vertically on the same line
    gap: 10,                   // space between label and input
    textAlign: "left",
    //maxWidth: 480,
    minWidth: 400,
    flex: "1 1 400px"
  };

const CustomSettingField = ({ field, type, defaultValue, options={} }) => {
  const { user, updateCookie } = useAuth();

  if (user.UserCustomSettings[field] === undefined) {
    changeCustomSetting(defaultValue);
  }

  function changeCustomSetting(newval) {
    user.UserCustomSettings[field] = newval;
    updateCookie(user);
  }

  return (
    <div style={panelStyle}>
      <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Default Graph</label>
      { type === "select" ? (
        <select id="preferredGraph" defaultValue={ user.UserCustomSettings[field] } onChange={(event) => changeCustomSetting(event.target.value) }>
          { Object.keys(options).map((val, idx) => (
            <option value={val} key={idx}>{options[val]}</option>
          )) }
        </select>
      ) : (<></>)}
    </div>
  )

}

const ProfilePage = ({ onClose } = {}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [desc, setDesc] = useState(user?.UserDescription || "");
  const [managers, setManagers] = useState([]);
  const [manager, setManager] = useState(user?.UserManager || "");
  const [dailyHours, setDailyHours] = useState(user?.UserDailyHours || 7.5);
  const [shiftMon, setShiftMon] = useState((user?.UserShiftMask & 1) !== 0);
  const [shiftTue, setShiftTue] = useState((user?.UserShiftMask & 2) !== 0);
  const [shiftWed, setShiftWed] = useState((user?.UserShiftMask & 4) !== 0);
  const [shiftThu, setShiftThu] = useState((user?.UserShiftMask & 8) !== 0);
  const [shiftFri, setShiftFri] = useState((user?.UserShiftMask & 16) !== 0);
  const [shiftSat, setShiftSat] = useState((user?.UserShiftMask & 32) !== 0);
  const [shiftSun, setShiftSun] = useState((user?.UserShiftMask & 64) !== 0);
  // eslint-disable-next-line
  const [customSettings, setCustomSettings] = useState({});
  // single open section name (only one open at a time). Default: first section open.

  // eslint-disable-next-line
  const updateCustomSetting = (name, value) => {
    setCustomSettings(prev => ({ ...prev, [name]: value }))
  }

  useEffect(() => {
    user.dailyHours = dailyHours
    user.shiftMon = shiftMon
    user.shiftTue = shiftTue
    user.shiftWed = shiftWed
    user.shiftThu = shiftThu
    user.shiftFri = shiftFri
    user.shiftSat = shiftSat
    user.shiftSun = shiftSun
  }, [dailyHours, user, shiftMon, shiftTue, shiftWed, shiftThu, shiftFri, shiftSat, shiftSun])

  const [shiftStatus, setShiftStatus] = useState("");

  const saveShiftOnly = async (e) => {
    e && e.preventDefault();
    setShiftStatus("saving");
    try {
      let result = 0
      if (shiftMon) result += 1
      if (shiftTue) result += 2
      if (shiftWed) result += 4
      if (shiftThu) result += 8
      if (shiftFri) result += 16
      if (shiftSat) result += 32
      if (shiftSun) result += 64
      await apiFetch("/api/me", {
        method: "PUT",
        body: JSON.stringify({
          UserDescription: desc || user.UserDescription,
          UserManager: manager || user.UserManager,
          UserDailyHours: dailyHours || user.UserDailyHours,
          UserShiftMask: result || user.UserShiftMask,
          UserCustomSettings: user.UserCustomSettings
        }),
      });
      user.UserDescription = desc
      user.UserManager = manager
      user.UserDailyHours = dailyHours
      user.UserShiftMask = result
      setShiftStatus("saved");
      setTimeout(() => setShiftStatus(""), 2000);
    } catch (e) {
      setShiftStatus("error:" + e);
    }
  };

  useEffect(() => {
    // fetch UT_Code options (requires auth) — only run when user is present
    if (!user) return;
    (async () => {
      try {
        const m = await apiFetch("/api/managers");
        if (m && Array.isArray(m.managers)) setManagers(m.managers);
      } catch (e) {
        // ignore
      }
    })();
  }, [user]);

  if (!user) return <p>The mirror is stays blank as you peer in; there is nothing to reflect.</p>;

  const messages = Object.freeze({
    saved: "Saved Changes.",
    saving: "Saving ...",
    error: "Could not save changes."
  })

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <h2>Profile</h2>
        <button
          className="vivid-button"
          style={{ "--bg": "#386795", width: "auto", marginLeft: 20, marginRight: 10 }}
          disabled={shiftStatus === "saving"}
          onClick={saveShiftOnly}
        >
          <b>{shiftStatus === "saving" ? ("Saving...") : ("Save profile")}</b>
        </button>
        <button
          className="vivid-button"
          style={{ "--bg": "#386795", width: "auto", marginLeft: 10, marginRight: 20 }}
          disabled={shiftStatus === "saving"}
          onClick={() => { if (onClose) { onClose() } else navigate("/main") }}
        >
          <b>Back to Main</b>
        </button>
        <label style={{ marginLeft: 16, color: !shiftStatus.startsWith("error") ? "green" : "darkred" }}>
          {shiftStatus !== "" && !shiftStatus.startsWith("error") ? (<p>
            {messages[shiftStatus] || "An unexpected error occured."}
          </p>) : (<></>)}
          {shiftStatus.startsWith("error") ? (<p>
            {messages["error"] + " : " + shiftStatus.split(":")[1]}
          </p>) : (<></>)}
        </label>
      </div>
      <section style={{ marginBottom: 24 }}>
        <div>
          <form style={{ display: "flex", gap: 16, alignItems: "stretch", flexWrap: "wrap" }}>
            <div style={panelStyle}>
              <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Full name</label>
              <input style={{ width: "auto", flex: "1 1 120px" }} value={desc} onChange={(e) => setDesc(e.target.value)} />
            </div>
            <div style={panelStyle}>
              <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Manager</label>
              <select style={{ width: "auto", flex: "1 1 120px" }} aria-label="Manager" value={manager} onChange={(e) => setManager(e.target.value)}>
                <option value="">(not set)</option>
                {managers.map((m) => (
                  <option key={m.code} value={m.code}>
                    {m.desc}
                  </option>
                ))}
              </select>
            </div>
            <div style={panelStyle}>
              <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Daily Hours</label>
              <input
                style={{ width: "auto", flex: "1 1 120px" }}
                type="number"
                step="0.25"
                min="0"
                max="24"
                value={dailyHours}
                onChange={(e) => setDailyHours(Number(e.target.value))}
              />
            </div>
            <div style={panelStyle}>
              <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Shift Pattern</label>
              <div style={{ flex: "1 1 120px", display: "flex", justifyContent: "center" }}>
                <div style={{ flex: "1 1 120px", display: "grid", gridAutoFlow: "column", gridTemplateRows: "auto auto", textAlign: "center", maxWidth: 300, minWidth: 300 }}>
                  <input
                    type="checkbox"
                    checked={shiftMon}
                    onChange={(e) => setShiftMon(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Mon</p>
                  <input
                    type="checkbox"
                    checked={shiftTue}
                    onChange={(e) => setShiftTue(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Tue</p>
                  <input
                    type="checkbox"
                    checked={shiftWed}
                    onChange={(e) => setShiftWed(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Wed</p>
                  <input
                    type="checkbox"
                    checked={shiftThu}
                    onChange={(e) => setShiftThu(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Thu</p>
                  <input
                    type="checkbox"
                    checked={shiftFri}
                    onChange={(e) => setShiftFri(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Fri</p>
                  <input
                    type="checkbox"
                    checked={shiftSat}
                    onChange={(e) => setShiftSat(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Sat</p>
                  <input
                    type="checkbox"
                    checked={shiftSun}
                    onChange={(e) => setShiftSun(e.target.checked)}
                  />
                  <p style={{ margin: 0 }}>Sun</p>
                </div>
              </div>
            </div>
            {/* <div style={panelStyle}>
              <label style={{ marginRight: 0, fontSize: 18, fontWeight: "bold" }}>Default Graph</label>
              <select id="preferredGraph">
                <option value="line" selected={ user.UserCustomSettings.preferredGraph === "line" }>Line Chart</option>
                <option value="bar" selected={ user.UserCustomSettings.preferredGraph === "bar" }>Bar Chart</option>
                <option value="pie" selected={ user.UserCustomSettings.preferredGraph === "pie" }>Pie Chart</option>
              </select>
            </div> */}
            <CustomSettingField 
              type={"select"}
              field={"preferredGraph"}
              options={{
                line: "Line",
                bar: "Bar",
                pie: "Pie"
              }}
            />
          </form>
        </div>
      </section>
    </div>
  );
};

export default ProfilePage;
